import React, { useRef, useState } from "react";
import Button from "@mui/material/Button";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { Box, TextField } from "@mui/material";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { useEffect } from "react";
import { DialogConstants } from "./Content";
import { AddBundleNoteDialogWrapper } from "./AddBundleNoteDialogStyled";
const AddBundleNoteDialog = ({
    show,
    title,
    heading,
    popupType,
    imgsrc,
    showError,
    textboxError,
    samLeadershipList,
    dialogText,
    handleTextBoxChange,
    handleSelectChange,
    handleConfirmClick,
    handleCancelClick
}) => {
    const inputRef = useRef(null);
    React.useEffect(() => {
        if (inputRef.current) {
            inputRef.current.focus();
        }
    });    
    const [submitError, setubSubmitError] = useState(
        popupType === 1 ? textboxError : ""
    );

    useEffect(() => {
        setubSubmitError(textboxError);
    }, [textboxError]);

    const handleChange = (e) => {

        let value = e?.target?.value;
        if (typeof value === "undefined " || !value || value?.trim() === "") {
            setubSubmitError("This field is required.");
        } else {
            setubSubmitError("");
        }
        handleTextBoxChange(value);
    };

    const handleSubmit = () => {

        if (
            typeof dialogText === "undefined" ||
            !dialogText ||
            dialogText?.trim() === ""
        ) {
            setubSubmitError("This field is required.");
        } else {
            setubSubmitError("");
            handleConfirmClick();
            return;
        }
        let commentError = "";
        if (
            (popupType === DialogConstants.APPROVE || popupType === DialogConstants.NOTE || popupType === DialogConstants.REJECT) &&
            (!dialogText || dialogText.trim() === "")
        ) {
            commentError = "This field is required.";
        }
        setubSubmitError(commentError);
        if (!commentError) {
            handleConfirmClick();
            return;
        }
        handleConfirmClick();
        return;
    };

    return (
        <div>
            <AddBundleNoteDialogWrapper
                open={show}
                onClose={handleCancelClick}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                scroll="paper"
                maxWidth="xs"
                fullWidth={true}
            >
                <DialogTitle id="alert-dialog-title" className="customDialogTitle">
                    {title}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText
                        id="alert-dialog-description"
                        className="customDialog"
                    >
                        <div>
                            <img src={imgsrc} alt="img" />
                        </div>
                        <div className={popupType === DialogConstants.NOTE ? "note" : ""}>{heading}</div>
                        {popupType === DialogConstants.APPROVE && (
                            <div>
                                <div className="inputform">
                                    <TextField
                                        className="formValue"
                                        onChange={handleChange}
                                        placeholder="Any comments? Please type here."
                                        multiline
                                        rows={4}
                                        name="note"
                                    />
                                    <Box className="errorBox">
                                        {submitError && (
                                            <span className="error">{submitError}</span>
                                        )}
                                    </Box>
                                </div>
                                <div>
                                    <FormControl className="customDropdown">
                                        <Select
                                            defaultValue={0}
                                            onChange={handleSelectChange}
                                            size="small"
                                        >
                                            <MenuItem disabled value={0}>
                                                Select Approver
                                            </MenuItem>
                                            {samLeadershipList.map((option) => (
                                                <MenuItem key={option.userId} value={option.userId}>
                                                    {`${!option.lastName ? "" : option.lastName},${!option.firstName ? "" : option.firstName}`}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                    <Box className="errorBox">
                                        {showError && <span className="error">{showError}</span>}
                                    </Box>
                                </div>
                            </div>
                        )}
                        {popupType === DialogConstants.NOTE && (
                            <div>
                                <div className="inputform">
                                    <TextField
                                        className="formValue"
                                        error={!!submitError}
                                        onChange={handleChange}
                                        helperText={submitError}
                                        placeholder="Type here."
                                        multiline
                                        rows={4}
                                        name="note"
                                    />
                                </div>
                            </div>
                        )}
                        {popupType === DialogConstants.REJECT && (
                            <div>
                                <div className="inputform">
                                    <TextField
                                        inputRef={inputRef}
                                        className="formValue"
                                        onChange={handleChange}
                                        placeholder="Type here."
                                        multiline
                                        rows={4}
                                        name="note"
                                    />
                                </div>
                                <Box>
                                    {submitError !== "" && (
                                        <span className="error">{submitError}</span>
                                    )}
                                </Box>
                            </div>
                        )}
                    </DialogContentText>
                </DialogContent>
                <DialogActions className="dialogbutton">
                    {popupType === DialogConstants.CONFIRM && (
                        <Button
                            variant="contained"
                            className="confirmButton"
                            onClick={
                                (e) => {
                                    handleConfirmClick()
                                }}
                        >
                            OK
                        </Button>
                    )}
                    {popupType !== DialogConstants.CONFIRM && (
                        <>
                            <Button
                                variant="outlined"
                                className="rightButton"
                                onClick={handleCancelClick}
                            >
                                Cancel
                            </Button>
                            <Button
                                variant="contained"
                                className="confirmButton"
                                onClick={(e) => {
                                    handleSubmit()
                                }}
                            >
                                Confirm
                            </Button>
                        </>
                    )}
                </DialogActions>
            </AddBundleNoteDialogWrapper>
        </div>
    );
};

export default AddBundleNoteDialog;
